// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-input {
  width: 100%;
  height: 4.6rem;
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: var(--black);
  background: transparent !important;
  border: 0;
  outline: none;
}
.app-input::placeholder {
  color: var(--grey-text);
  background: transparent !important;
}
.app-input:disabled, .app-input[disabled] {
  color: var(--grey-text);
  cursor: not-allowed;
  -webkit-text-fill-color: var(--grey-text);
  opacity: 0.8;
}
.app-input.medium {
  height: 3.4rem;
  font-size: 1.4rem;
  line-height: 1.7rem;
}
.app-input.small {
  height: 3rem;
  font-size: 1.4rem;
  line-height: 1.7rem;
}`, "",{"version":3,"sources":["webpack://./src/shared/input/input.component.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,cAAA;ECHA,iBAAA;EACA,mBAAA;EDIA,mBAAA;EACA,kCAAA;EACA,SAAA;EACA,aAAA;AAAF;AAGE;EACE,uBAAA;EACA,kCAAA;AADJ;AAIE;EAEE,uBAAA;EACA,mBAAA;EACA,yCAAA;EACA,YAAA;AAHJ;AAME;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;AAJJ;AAOE;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;AALJ","sourcesContent":["@import 'src/styles/mixins';\n\n.app-input {\n  width: 100%;\n  height: 4.6rem;\n  @include button-text;\n  color: var(--black);\n  background: transparent !important;\n  border: 0;\n  outline: none;\n  // box-shadow: inset 0 0 0 50px var(--white);\n\n  &::placeholder {\n    color: var(--grey-text);\n    background: transparent !important;\n  }\n\n  &:disabled,\n  &[disabled] {\n    color: var(--grey-text);\n    cursor: not-allowed;\n    -webkit-text-fill-color: var(--grey-text);\n    opacity: 0.8;\n  }\n\n  &.medium {\n    height: 3.4rem;\n    font-size: 1.4rem;\n    line-height: 1.7rem;\n  }\n\n  &.small {\n    height: 3rem;\n    font-size: 1.4rem;\n    line-height: 1.7rem;\n  }\n}\n","@mixin button-text {\n  font-size: 1.6rem;\n  line-height: 1.9rem;\n}\n\n@mixin button-medium-text {\n  font-size: 1.2rem;\n  line-height: 1.4rem;\n}\n\n@mixin small-button-text {\n  font-size: 1.4rem;\n  line-height: 1.7rem;\n}\n\n@mixin label {\n  font-size: 1.4rem;\n  line-height: 1.8rem;\n  font-weight: 500;\n}\n\n@mixin full {\n  &.full {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
